import { advancedSearchPayloadType, simpleSearchPayloadType } from "type/homeType";
import { apiHeaderOptions, apiPostHeaderOptions } from "./apiHeaderOptions";
import api from "api";

const records:any = [
  {
    type: 'Image',
    title: 'Sample Image 12233',
    filename: 'sample_image.jpg',
    publishedDate: '2023-10-01',
    lotNumber: '12345331',
    sku: 'SKU12345',
    assetType:'Citiation'
  },
  {
    type: 'Video',
    title: 'Sample Video',
    filename: 'sample_video.mp4',
    publishedDate: '2023-10-02',
    lotNumber: '123457',
    sku: 'SKU12346',
    assetType:'SDS'
  },
  {
    type: 'Document',
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'Citiation'
  },
  {
    type: 'Excel',
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'SDS'
  },
  {
    type: 'Excel',
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'Citiation'
  },
  {
    type: Document,
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'Citiation'
  },
  {
    type: Document,
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'Citiation'
  },
  {
    type: Document,
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'Citiation'
  },
  {
    type: Document,
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'Citiation'
  },
  {
    type: Document,
    title: 'Sample Document',
    filename: 'sample_document.pdf',
    publishedDate: '2023-10-03',
    lotNumber: '123458',
    sku: 'SKU12347',
    assetType:'SDS'
  },
];
// advanced search with user details - recent records
const fetchRecentRecords = async (payload:advancedSearchPayloadType) => {
  const searchApiUrl = api.config.getAdvancedSearch(payload.pageNumber, payload.pageSize);
  const requestOptions = apiPostHeaderOptions();
  requestOptions.body = JSON.stringify({
    search_criteria: {
      imported_by: {
        operator: 0,
        operation: "is",
        argument: payload.userId,
        type: "text"
      },
    }
  });

  return fetch(searchApiUrl, requestOptions);
};

// simple search - with only keyword
const fetchSimpleSearch = async (payload:simpleSearchPayloadType) => {
  const searchApiUrl = api.config.getSimpleSearch(payload.keyword, payload.pageNumber, payload.pageSize);
  const requestOptions = apiHeaderOptions();
  return fetch(searchApiUrl, requestOptions);
};

export const homeService = {
  fetchRecentRecords,
  fetchSimpleSearch
};